import React from 'react'
import Layout from './src/components/Layout'

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import './src/styles/global.scss'

export function wrapPageElement({ element, props }) {
  return <Layout {...props}>{element}</Layout>
}
